/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FloatCalculationDataTransferObject
 */
export interface FloatCalculationDataTransferObject {
    /**
     * 
     * @type {number}
     * @memberof FloatCalculationDataTransferObject
     */
    percentageChangeAgainstPreviousPeriod?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FloatCalculationDataTransferObject
     */
    value?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FloatCalculationDataTransferObject
     */
    valuePreviousPeriod?: number | null;
    /**
     * 
     * @type {{ [key: string]: number | null; }}
     * @memberof FloatCalculationDataTransferObject
     */
    valueGranular?: { [key: string]: number | null; };
    /**
     * 
     * @type {{ [key: string]: number | null; }}
     * @memberof FloatCalculationDataTransferObject
     */
    valueGranularPreviousPeriod?: { [key: string]: number | null; };
}

/**
 * Check if a given object implements the FloatCalculationDataTransferObject interface.
 */
export function instanceOfFloatCalculationDataTransferObject(value: object): value is FloatCalculationDataTransferObject {
    return true;
}

export function FloatCalculationDataTransferObjectFromJSON(json: any): FloatCalculationDataTransferObject {
    return FloatCalculationDataTransferObjectFromJSONTyped(json, false);
}

export function FloatCalculationDataTransferObjectFromJSONTyped(json: any, ignoreDiscriminator: boolean): FloatCalculationDataTransferObject {
    if (json == null) {
        return json;
    }
    return {
        
        'percentageChangeAgainstPreviousPeriod': json['percentageChangeAgainstPreviousPeriod'] === undefined ? undefined : json['percentageChangeAgainstPreviousPeriod'] === null ? null : json['percentageChangeAgainstPreviousPeriod'],
        'value': json['value'] === undefined ? undefined : json['value'] === null ? null : json['value'],
        'valuePreviousPeriod': json['valuePreviousPeriod'] === undefined ? undefined : json['valuePreviousPeriod'] === null ? null : json['valuePreviousPeriod'],
        'valueGranular': json['valueGranular'] == null ? undefined : json['valueGranular'],
        'valueGranularPreviousPeriod': json['valueGranularPreviousPeriod'] == null ? undefined : json['valueGranularPreviousPeriod'],
    };
}

export function FloatCalculationDataTransferObjectToJSON(json: any): FloatCalculationDataTransferObject {
    return FloatCalculationDataTransferObjectToJSONTyped(json, false);
}

export function FloatCalculationDataTransferObjectToJSONTyped(value?: FloatCalculationDataTransferObject | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'percentageChangeAgainstPreviousPeriod': value['percentageChangeAgainstPreviousPeriod'],
        'value': value['value'],
        'valuePreviousPeriod': value['valuePreviousPeriod'],
        'valueGranular': value['valueGranular'],
        'valueGranularPreviousPeriod': value['valueGranularPreviousPeriod'],
    };
}

